import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { Accordion, AccordionContent, AccordionHeader, AccordionPanel } from 'primeng/accordion';

import { AccordionMonoPT } from '@advania-cosoftware/advania-styles';

@Component({
    selector: 'app-gdpr-info',
    templateUrl: './gdpr-info.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [Accordion, AccordionContent, AccordionHeader, AccordionPanel, TranslocoDirective],
})
export class GdprInfoComponent {
    contactUsUrl = 'https://www.advania.no/om-oss/kontakt-oss';

    privacyPolicyUrl = 'https://www.advania.no/personvernerklaering';
    protected readonly AccordionMonoPT = AccordionMonoPT;
}
